import axios from 'axios'
import base from '../../base'
import resource from './resource'

export default {
  requestData() {
    const config = {
      url: resource,
      baseURL: base
    }

    return axios(config)
  }
}
